import React, { createContext, useContext, useState, useCallback } from "react";

export const CookieContext = createContext(null);

export const CookieProvider = ({ children }) => {
  const [cookies, setCookies] = useState({});

  const setCookie = useCallback((cookieName, value) => {
    setCookies((prevCookies) => ({
      ...prevCookies,
      [cookieName]: value,
    }));
  }, []);

  const removeCookie = useCallback((cookieName) => {
    setCookies((prevCookies) => {
      const newCookies = { ...prevCookies };
      delete newCookies[cookieName];
      return newCookies;
    });
  }, []);

  return (
    <CookieContext.Provider value={{ cookies, setCookie, removeCookie }}>
      {children}
    </CookieContext.Provider>
  );
};

export const useCookie = (cookieName) => {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error("useCookie must be used within a CookieProvider");
  }

  const { cookies, setCookie, removeCookie } = context;

  return [
    cookies[cookieName],
    (value) => setCookie(cookieName, value),
    () => removeCookie(cookieName),
  ];
};
